export function setAttributes(element, attributes) {
  Object.keys(attributes).forEach((key) => {
    element.setAttribute(key, attributes[key]);
  });
}

export function createEl(tag, classes, textNode, attributes) {
  const element = document.createElement(tag);
  if (classes) {
    element.className = classes;
  }
  if (textNode) {
    element.textContent = textNode;
  }
  if (attributes) {
    setAttributes(element, attributes);
  }
  return element;
}

export function createBtn(classes, title) {
  return createEl('button', classes, title, { type: 'button' });
}

export function createScript(src) {
  const element = document.createElement('script');
  const attributes = {
    src,
    async: true,
    defer: true,
  };
  setAttributes(element, attributes);
  return element;
}


export function getFormData(form) {
  if ('elements' in form) {
    const data = {};
    Array.from(form.elements).forEach((el) => {
      if (el.id && el.value) {
        const key = el.id.split('-').slice(1).join(' ');
        data[key] = el.value;
      }
    });
    return data;
  }
  return null;
}

export function toggle(hide, show, value = 'flex') {
  hide.style.display = 'none';
  show.style.display = value;
}
export function removeClass(elem, className) {
  const classList = elem.className.split(' ');
  elem.className = classList.filter(name => name !== className).join(' ');
}

export function scrollTo(element, to, duration) {
  if (duration <= 0) return;
  const difference = to - element.scrollLeft;
  const perTick = (difference / duration) * 10;

  setTimeout(() => {
    element.scrollLeft += perTick;
    if (element.scrollLeft === to) return;
    scrollTo(element, to, duration - 2);
  }, 0);
}


export function fontLoader() {
  const entry = document.getElementsByTagName('script')[0];
  entry.parentNode.insertBefore(
    createEl('link', '', '', {
      href: 'https://fonts.googleapis.com/icon?family=Material+Icons',
      rel: 'stylesheet',
    }),
    entry,
  );
  entry.parentNode.insertBefore(
    createEl('link', '', '', {
      href: 'https://fonts.googleapis.com/css?family=Lato:300,400,700,900',
      rel: 'stylesheet',
    }),
    entry,
  );
}

export function scriptLoader(src) {
  const entry = document.getElementsByTagName('script')[0];
  return entry.parentNode.insertBefore(
    createScript(src),
    entry,
  );
}



// WEBPACK FOOTER //
// ./src/helpers/domHelpers.js